import { useQuery } from '@tanstack/react-query';
import { eventsApi } from '@/api/events';
import { queryKeys } from '@/query/queryKeys';

type Params = { from: string; to: string; calendarId?: string };

const useEventsQuery = (params: Params, options: { enabled?: boolean } = {}) =>
  useQuery({
    queryKey: queryKeys.events(params),
    queryFn: () => eventsApi.list(params),
    enabled: (options.enabled ?? true) && Boolean(params.from && params.to),
  });

export { useEventsQuery };
